import type { FlowValueType } from '../types';
import type { CompareOperator } from './flowNodeDefinitions';

function asArray(value: unknown) {
  return Array.isArray(value) ? value : [];
}

export function evaluateCompare(args: {
  operator: CompareOperator;
  leftValue: unknown;
  rightValue: unknown;
  valueType: FlowValueType;
}) {
  const { operator, leftValue, rightValue, valueType } = args;

  switch (operator) {
    case 'equals':
      return leftValue === rightValue;
    case 'notEquals':
      return leftValue !== rightValue;
    case 'greaterThan':
      return Number(leftValue) > Number(rightValue);
    case 'lessThan':
      return Number(leftValue) < Number(rightValue);
    case 'contains':
      if (valueType === 'list.string' || valueType === 'list.request-item') {
        return asArray(leftValue).some((entry) => entry === rightValue);
      }
      if (typeof leftValue === 'string' && typeof rightValue === 'string') {
        return leftValue.toLowerCase().includes(rightValue.toLowerCase());
      }
      return false;
    case 'isEmpty':
      if (Array.isArray(leftValue)) return leftValue.length === 0;
      if (typeof leftValue === 'string') return leftValue.trim().length === 0;
      return leftValue === null || leftValue === undefined;
    case 'isNotEmpty':
      if (Array.isArray(leftValue)) return leftValue.length > 0;
      if (typeof leftValue === 'string') return leftValue.trim().length > 0;
      return leftValue !== null && leftValue !== undefined;
    default:
      return false;
  }
}

export function evaluateCondition(condition: unknown, trueValue: unknown, falseValue: unknown) {
  return condition === true ? trueValue : falseValue;
}
